import React, { useEffect } from 'react'
import { CssBaseline, Grid, makeStyles } from '@material-ui/core'
import '../index.css'
import { QUESTION_TYPES } from '../QuestionTypes'
import { QuestionTypesMenu } from '../Molecules/QuestionTypesMenu'
import { QuestionsArea } from '../Organisms/QuestionsArea'
import { JSONTranslationArea } from '../Organisms/JSONTranslationArea'
import { useDispatch, useSelector } from 'react-redux'
import {
  CLEAR_MAPS,
  initializeMaps,
} from '../../features/State Management/utilitiesSlice'
import BackToTopArrowButton from '../Atoms/Buttons/BackToTopArrowButton'
import QuestionnaireTitle from '../Atoms/QuestionnaireTitle'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
}))

const MainPage = () => {
  const questions = useSelector((state) => state.questions)
  const dispatch = useDispatch()
  const classes = useStyles()

  useEffect(() => {
    dispatch(initializeMaps(questions))
    return () => dispatch(CLEAR_MAPS())
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div data-cy='questionsPage' className={classes.root}>
      <CssBaseline />
      <QuestionTypesMenu items={QUESTION_TYPES} />
      <main className={classes.content}>
        <Grid
          container
          direction='column'
          justifyContent='center'
          alignItems='stretch'
          style={{
            margin: '0',
          }}
        >
          <QuestionnaireTitle />
          <JSONTranslationArea />
          <QuestionsArea />
          <BackToTopArrowButton />
        </Grid>
      </main>
    </div>
  )
}

export default MainPage
